// Liste des catégories de projets disponibles dans le formulaire de soumission
// et utilisée pour les filtres listing.
export const PROJECT_CATEGORIES = [
  'DeFi',
  'GameFi',
  'SocialFi',
  'Meme',
  'AI',
  'RWA',
  'Infrastructure',
  'NFT',
  'Metaverse',
  'DEX',
  'Layer 1',
  'Layer 2',
  'Autre',
];

export const isValidCategory = (cat) => PROJECT_CATEGORIES.includes(cat);

////////////////////////////
// Utilitaires URL vidéo YouTube
////////////////////////////

// Extrait l'ID YouTube depuis n'importe quel format d'URL supporté.
// Retourne null si l'URL n'est pas une URL YouTube valide.
export function extractYouTubeId(url) {
  if (!url || typeof url !== 'string') return null;
  const patterns = [
    /(?:youtube\.com\/watch\?[^#]*v=)([a-zA-Z0-9_-]{11})/,
    /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/,
  ];
  for (const re of patterns) {
    const m = url.match(re);
    if (m && m[1]) return m[1];
  }
  return null;
}

export const isValidYouTubeUrl = (url) => extractYouTubeId(url) !== null;

// Retourne l'URL d'embed YouTube prête à utiliser dans une iframe.
export function getYouTubeEmbedUrl(url) {
  const id = extractYouTubeId(url);
  return id ? `https://www.youtube.com/embed/${id}` : null;
}
